"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ExpiredCountdown;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _button = _interopRequireDefault(require("../merch-button/button.js"));
var _text = _interopRequireDefault(require("@ux/text"));
/**
* Render ExpiredCountdown
*
* @param {object} props React props for ExpiredCountdown element
* @param {string} props.title Expired countdown's title
* @param {object} props.afterExpirationButton Button to appear after countdown expiration
* @returns {React.ReactElement} ExpiredCountdown component
* @public
*/
function ExpiredCountdown({
  title,
  afterExpirationButton
}) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && /*#__PURE__*/_react.default.createElement(_text.default.div, {
    as: "title",
    className: "expired-countdown-title",
    "data-cy": "expired-countdown-title"
  }, title), afterExpirationButton && /*#__PURE__*/_react.default.createElement(_button.default, afterExpirationButton));
}
ExpiredCountdown.propTypes = {
  title: _propTypes.default.string,
  afterExpirationButton: _propTypes.default.shape(_button.default.propTypes)
};